interface TeamGradientProps {
  teamId: string;
  teamColor: string;
}

export const TeamGradient = ({ teamId, teamColor }: TeamGradientProps) => {
  return (
    <linearGradient id={teamId} x1="0%" y1="100%" x2="0%" y2="0%">
      <stop offset="0%" style={{ stopColor: "white", stopOpacity: 0 }} />
      <stop offset="100%" style={{ stopColor: teamColor, stopOpacity: 0.2 }} />
    </linearGradient>
  );
};
